import { Container, HamburgerButton } from './styles';
import WdLogo from '../../../WDLogo';
import { Icon } from '@iconify/react';

interface Props {
  onClick(): void;
  open: boolean;
}

function SideBarLogo({ onClick, open }: Props) {
  return (
    <Container open={open} onClick={onClick}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: open ? 'space-between' : 'center', marginTop: 10, width: '100%' }}>
        {open && <WdLogo open={open} size="120px" />}
        <HamburgerButton>
          <Icon icon="mdi:menu" style={{ fontSize: '24px', color: '#744cb4' }} />
        </HamburgerButton>
      </div>
    </Container>
  );
}

export default SideBarLogo;
